/* Diwali effects: pataka (firework) bursts and the optional click behaviour.
   - short auto show on arrival (setting), light a diya, lantern offer card.
   Never blocks page clicks; skipped bursts for reduced-motion. */
(function () {
  var root = document.querySelector('.dfx-page');
  if (!root) return;

  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var small = window.innerWidth < 750;
  /* ---- Fireworks engine: rocket with spark trail, star bursts with streaks, glitter ---- */
  var SHELLS = [
    ['#ffd166', '#ff9f1c'], ['#ffd166', '#ff9f1c'], ['#ffd166', '#ff9f1c'],
    ['#ff4d6d', '#ff8fa3'], ['#ff4d6d', '#ff8fa3'], ['#ff4d6d', '#ff8fa3'],
    ['#ff7b2e', '#ffb347'], ['#ff7b2e', '#ffb347'], ['#ff7b2e', '#ffb347'],
    ['#ff5fc8', '#c77dff'], ['#ff5fc8', '#c77dff'],
    ['#4cc9f0', '#90e0ef'], ['#80ed99', '#c7f9cc']
  ];
  var VEIL = 'rgba(14, 4, 10, 0.42)';
  var MAX_STARS = small ? 260 : 520;
  var MAX_SPARKS = small ? 380 : 800;

  var canvas = null, ctx = null, w = 0, h = 0, dpr = 1, closeTimer = null;
  var comets = [], stars = [], sparks = [], flashes = [], chakris = [];
  var running = false, last = 0, launchUntil = 0, nextLaunch = 0;

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function isOff() { return false; }

  function resize() {
    w = window.innerWidth;
    h = window.innerHeight;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function ensureCanvas(veil) {
    clearTimeout(closeTimer);
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'dfx-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      dpr = Math.min(window.devicePixelRatio || 1, small ? 1.5 : 2);
      resize();
      window.addEventListener('resize', resize);
    }
    if (veil) {
      requestAnimationFrame(function () { if (canvas) canvas.style.backgroundColor = VEIL; });
    }
  }

  function teardown() {
    running = false;
    comets = []; stars = []; sparks = []; flashes = []; chakris = [];
    if (!canvas) return;
    var c = canvas;
    c.style.backgroundColor = 'transparent';
    window.removeEventListener('resize', resize);
    canvas = null;
    closeTimer = setTimeout(function () { c.remove(); }, 650);
  }

  function addSpark(x, y, vx, vy, life, color, size) {
    if (sparks.length >= MAX_SPARKS) return;
    sparks.push({ x: x, y: y, px: x, py: y, vx: vx, vy: vy, life: life, full: life, color: color, size: size });
  }

  function addStar(x, y, vx, vy, life, color, o) {
    if (stars.length >= MAX_STARS) return;
    stars.push({
      x: x, y: y, px: x, py: y, vx: vx, vy: vy, life: life, full: life, color: color,
      drag: o.drag, grav: o.grav, size: o.size, glitter: o.glitter, gtimer: rnd(0, 6), strobe: o.strobe
    });
  }

  /* Burst: sphere (projected, dense at the rim), ring, or willow */
  function burst(x, y, shell, radius, kind) {
    var main = shell[0], alt = shell[1];
    var n = small ? 30 : 52;
    var willow = kind === 'willow';
    var ring = kind === 'ring';
    var drag = willow ? 0.972 : 0.965;
    var grav = willow ? 0.05 : 0.036;
    var v = radius * (1 - drag);
    var tilt = rnd(0.45, 1);
    var rot = rnd(0, 6.2832);
    var multi = !willow && Math.random() < 0.22;
    flashes.push({ x: x, y: y, r: radius * 1.1, a: 0.55, color: main });

    if (ring) n = Math.round(n * 0.6);
    for (var i = 0; i < n; i++) {
      var ang = ring ? (6.2832 * i) / n : rnd(0, 6.2832);
      var sp;
      if (ring) sp = v * rnd(0.97, 1.03);
      else { var z = rnd(-1, 1); sp = v * Math.sqrt(1 - z * z) * rnd(0.9, 1.05); }
      var vx = Math.cos(ang) * sp;
      var vy = Math.sin(ang) * sp;
      if (ring) {
        var rx = vx, ry = vy * tilt;
        vx = rx * Math.cos(rot) - ry * Math.sin(rot);
        vy = rx * Math.sin(rot) + ry * Math.cos(rot);
      }
      var col = multi ? SHELLS[(Math.random() * SHELLS.length) | 0][0] : (Math.random() < 0.18 ? alt : main);
      addStar(x, y, vx, vy,
        willow ? rnd(120, 170) : rnd(62, 100), willow ? '#ffd166' : col,
        { drag: drag, grav: grav, size: willow ? 1.7 : 2.3, glitter: willow ? 1 : (Math.random() < 0.4 ? 1 : 0), strobe: !willow && Math.random() < 0.12 });
    }
    // a few bright crackle sparks at the heart of the burst
    for (var k = 0; k < (small ? 8 : 14); k++) {
      var a2 = rnd(0, 6.2832), s2 = rnd(0.4, 2.4);
      addSpark(x, y, Math.cos(a2) * s2, Math.sin(a2) * s2, rnd(14, 26), '#fff4cf', 1.4);
    }
  }

  /* Rocket (comet) that climbs under gravity, shedding sparks, then bursts at the top */
  function launchRocket(opts) {
    opts = opts || {};
    var burstY = h * rnd(0.16, small ? 0.46 : 0.42);
    var x = opts.x != null ? opts.x : w * rnd(0.14, 0.86);
    var drag = 0.992, g = 0.05, need = h - burstY;
    var v = 6;
    for (; v < 40; v += 0.25) {
      var yy = 0, vv = v;
      for (var t = 0; t < 600 && vv > 0; t++) { yy += vv; vv = vv * drag - g; }
      if (yy >= need) break;
    }
    var roll = Math.random();
    comets.push({
      x: x, y: h + 6, vx: rnd(-0.35, 0.35), vy: -v, drag: drag, g: g,
      shell: SHELLS[(Math.random() * SHELLS.length) | 0],
      kind: roll < 0.2 ? 'ring' : (roll < 0.4 ? 'willow' : 'sphere'),
      radius: rnd(small ? 70 : 90, small ? 100 : 130)
    });
  }

  function frame(now) {
    if (!canvas) { running = false; return; }
    var dt = Math.min(2.2, (now - last) / 16.67);
    last = now;

    if (now < launchUntil && now >= nextLaunch) {
      launchRocket();
      nextLaunch = now + rnd(800, 1300);
    }

    // fade the previous frame away: this is what leaves the streaking trails
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,' + (0.24 * dt) + ')';
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineCap = 'round';

    // burst flashes
    for (var f = flashes.length - 1; f >= 0; f--) {
      var fl = flashes[f];
      fl.a -= 0.07 * dt;
      if (fl.a <= 0) { flashes.splice(f, 1); continue; }
      var grad = ctx.createRadialGradient(fl.x, fl.y, 0, fl.x, fl.y, fl.r);
      grad.addColorStop(0, 'rgba(255,240,200,' + fl.a + ')');
      grad.addColorStop(0.35, fl.color + '33');
      grad.addColorStop(1, 'rgba(255,200,120,0)');
      ctx.globalAlpha = Math.min(1, fl.a * 1.6);
      ctx.fillStyle = grad;
      ctx.fillRect(fl.x - fl.r, fl.y - fl.r, fl.r * 2, fl.r * 2);
    }

    // rockets
    for (var i = comets.length - 1; i >= 0; i--) {
      var c = comets[i];
      c.x += c.vx * dt;
      c.y += c.vy * dt;
      c.vy = c.vy * c.drag + c.g * dt;
      var trail = small ? 1 : 2;
      for (var s = 0; s < trail; s++) {
        addSpark(c.x + rnd(-1, 1), c.y + rnd(0, 3), rnd(-0.35, 0.35), rnd(0.2, 0.9), rnd(26, 44), '#ffcf70', 1.5);
      }
      ctx.globalAlpha = 0.35;
      ctx.fillStyle = '#ffb347';
      ctx.beginPath(); ctx.arc(c.x, c.y, 6, 0, 6.2832); ctx.fill();
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#fff2c4';
      ctx.beginPath(); ctx.arc(c.x, c.y, 2.4, 0, 6.2832); ctx.fill();
      if (c.vy > -0.35) {
        burst(c.x, c.y, c.shell, c.radius, c.kind);
        comets.splice(i, 1);
      }
    }

    // chakri: a ground spinner throwing sparks in a spiral
    for (var cq = chakris.length - 1; cq >= 0; cq--) {
      var ch = chakris[cq];
      ch.life -= dt;
      if (ch.life <= 0) { chakris.splice(cq, 1); continue; }
      ch.a += 0.55 * dt;
      var fade = Math.min(1, (ch.life / ch.full) * 1.6);
      for (var arm = 0; arm < 4; arm++) {
        var ang = ch.a + arm * 1.5708, cs = Math.cos(ang), sn = Math.sin(ang);
        addSpark(ch.x + cs * 9, ch.y + sn * 9, -sn * 2.6 + cs * 0.9 + rnd(-0.3, 0.3), cs * 2.6 + sn * 0.9 + rnd(-0.3, 0.3) - 0.2, rnd(14, 26), arm % 2 ? '#ffb347' : '#ffd166', 1.7);
      }
      ctx.globalAlpha = 0.5 * fade;
      ctx.fillStyle = '#ff9f1c';
      ctx.beginPath(); ctx.arc(ch.x, ch.y, 10, 0, 6.2832); ctx.fill();
      ctx.globalAlpha = fade;
      ctx.fillStyle = '#fff2c4';
      ctx.beginPath(); ctx.arc(ch.x, ch.y, 3.5, 0, 6.2832); ctx.fill();
    }

    // stars: long streaks with a soft halo
    var halo = !small;
    for (var j = stars.length - 1; j >= 0; j--) {
      var st = stars[j];
      st.life -= dt;
      if (st.life <= 0) { stars.splice(j, 1); continue; }
      st.px = st.x; st.py = st.y;
      st.x += st.vx * dt;
      st.y += st.vy * dt;
      var d = 1 - (1 - st.drag) * dt;
      st.vx *= d; st.vy = st.vy * d + st.grav * dt;
      var burn = st.life / st.full;
      if (st.glitter) {
        st.gtimer -= dt;
        if (st.gtimer <= 0) {
          st.gtimer = rnd(3, 7);
          addSpark(st.x, st.y, rnd(-0.3, 0.3), rnd(0, 0.5), rnd(26, 46), '#ffe9a8', 1.3);
        }
      }
      if (st.strobe && burn < 0.45 && Math.floor(st.life / 3) % 3 !== 0) continue;
      var alpha = burn < 0.35 ? burn / 0.35 : 1;
      ctx.strokeStyle = st.color;
      if (halo) {
        ctx.globalAlpha = alpha * 0.22;
        ctx.lineWidth = st.size * 2.6;
        ctx.beginPath(); ctx.moveTo(st.px, st.py); ctx.lineTo(st.x, st.y); ctx.stroke();
      }
      ctx.globalAlpha = alpha;
      ctx.lineWidth = st.size;
      ctx.beginPath(); ctx.moveTo(st.px, st.py); ctx.lineTo(st.x, st.y); ctx.stroke();
    }

    // sparks: tiny falling glitter and rocket exhaust
    for (var q = sparks.length - 1; q >= 0; q--) {
      var sp = sparks[q];
      sp.life -= dt;
      if (sp.life <= 0) { sparks.splice(q, 1); continue; }
      sp.px = sp.x; sp.py = sp.y;
      sp.x += sp.vx * dt;
      sp.y += sp.vy * dt;
      var d2 = 1 - 0.06 * dt;
      sp.vx *= d2; sp.vy = sp.vy * d2 + 0.028 * dt;
      ctx.globalAlpha = Math.min(1, (sp.life / sp.full) * 1.6);
      ctx.strokeStyle = sp.color;
      ctx.lineWidth = sp.size;
      ctx.beginPath(); ctx.moveTo(sp.px, sp.py); ctx.lineTo(sp.x, sp.y + 0.01); ctx.stroke();
    }
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';

    if (now < launchUntil || comets.length || stars.length || sparks.length || flashes.length || chakris.length) {
      requestAnimationFrame(frame);
    } else {
      teardown();
    }
  }

  function kick() {
    if (running) return;
    running = true;
    last = performance.now();
    nextLaunch = last;
    requestAnimationFrame(frame);
  }

  /* A show: a run of rockets over `ms`, with the night veil behind them */
  function show(ms, veil) {
    if (reduce || isOff()) return;
    ensureCanvas(veil !== false);
    launchUntil = Math.max(launchUntil, performance.now() + ms);
    kick();
  }

  /* Chakri at a point (pre-order button) */
  function chakri(x, y) {
    if (reduce || isOff()) return;
    ensureCanvas(false);
    chakris.push({ x: x, y: y, a: 0, life: 110, full: 110 });
    kick();
  }

  /* A small burst at a point (lantern click) */
  function pop(x, y) {
    if (reduce || isOff()) return;
    ensureCanvas(false);
    burst(x, y, SHELLS[(Math.random() * SHELLS.length) | 0], small ? 70 : 90, 'sphere');
    kick();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pk-chakri]');
    if (!b || !e.isTrusted) return;
    var r = b.getBoundingClientRect();
    if (!r.width || !r.height) return;
    chakri(r.left + r.width / 2, r.top + r.height / 2);
  }, true);

  /* ---- Toast ---- */
  var toastEl = root.querySelector('.dfx-toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* ---- Light a diya ---- */
  function litCount() {
    var n = 0;
    try { n = parseInt(sessionStorage.getItem('dfx-lit') || '0', 10) || 0; } catch (e) {}
    n += 1;
    try { sessionStorage.setItem('dfx-lit', String(n)); } catch (e) {}
    return n;
  }
  root.querySelectorAll('.dfx-corner').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.add('is-lit');
      setTimeout(function () { btn.classList.remove('is-lit'); }, 1900);
      var n = litCount();
      toast('Happy Diwali! 🪔 You have lit ' + n + ' diya' + (n > 1 ? 's' : ''));
      show(1200, false);
    });
  });

  /* ---- Lantern click: offer card when a code is set, otherwise the link works as normal ---- */
  var card = root.querySelector('.dfx-card');
  var code = root.getAttribute('data-dfx-coupon-code');
  function closeCard() { if (card) card.hidden = true; }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.dfx-lantern-link');
    if (!link) return;
    pop(e.clientX, e.clientY);
    if (card && code) {
      e.preventDefault();
      card.hidden = false;
      var closeBtn = card.querySelector('.dfx-card__close');
      if (closeBtn) closeBtn.focus();
    }
  });
  if (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-dfx-close]')) closeCard();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !card.hidden) closeCard();
    });
    var copyBtn = card.querySelector('[data-dfx-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        function done() {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (e) {}
          t.remove();
          done();
        }
      });
    }
  }

  /* ---- Automatic show on arrival ---- */
  var mode = root.getAttribute('data-dfx-fireworks');
  if (mode === 'off' || reduce || isOff()) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (mode === 'session') {
    try {
      if (sessionStorage.getItem('dfx-shown')) return;
      sessionStorage.setItem('dfx-shown', '1');
    } catch (e) {}
  }
  function schedule() { setTimeout(function () { show(3200, false); }, 900); }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
